import { Link } from "react-router-dom";
import pompageImg from "../../images/pompage.png";
import ReactPlayer from "react-player";

const MissionWater = () => {
  return (
    <div className="container px-4 mx-auto mt-10 mb-10 sm:px-6 lg:px-8">
      <p className="mt-2 text-base font-bold text-center">
        <span className="text-primary">Collecter</span>,{" "}
        <span className="text-primary">transporter</span>, puis{" "}
        <span className="text-primary">traiter</span> les eaux usées de 31
        communes avant de les rejeter dans leur milieu naturel… telles sont les
        principales missions d’<span className="text-primary">Hydreaulys</span>.
      </p>

      <div className="flex justify-center mt-6 mb-6">
        <img
          src={pompageImg}
          alt="Pompage d'eaux usées"
          className="object-cover w-full h-auto max-w-md rounded-lg"
        />
      </div>

      <p className="mt-10 text-base text-center">
        Plus qu’un simple maître d’ouvrage, ce syndicat est l’héritier
        d’installations qui remontent à l’époque de Louis XIV ! Préserver ce
        patrimoine constitue aussi l’une de ses vocations. Mais Hydreaulys est
        également tourné vers l’avenir et poursuit un objectif fondamental :
        diminuer l’impact de l’homme sur{" "}
        <Link
          to={"https://aquavesc.fr/eau?cycle"}
          target="_blank"
        >
          <span className="underline">le cycle hydrologique</span>
        </Link>
          et œuvrer pour une circulation responsable de l’eau.
      </p>

      <div className="flex justify-center my-6">
        <div className="overflow-hidden rounded-lg w-[450px] h-[260px]">
          <ReactPlayer
            playing={false}
            url="https://www.youtube.com/watch?v=-UNTupxO7JU&t=1s"
            width="100%"
            height="100%"
          />
        </div>
      </div>
    </div>
  );
};

export default MissionWater;
